export const VALIDATE_USER = 1;
export const VALIDATE_OTP = 2;
export const VALIDATED = 3;
